export const ORDER_LIST_REQUEST = 'ORDER_LIST_REQUEST'
export const ORDER_LIST_SUCCESS = 'ORDER_LIST_SUCCESS'
export const ORDER_LIST_FAIL = 'ORDER_LIST_FAIL'

export const SELLREQUEST_LIST_REQUEST = 'SELLREQUEST_LIST_REQUEST'
export const SELLREQUEST_LIST_SUCCESS = 'SELLREQUEST_LIST_SUCCESS'
export const SELLREQUEST_LIST_FAIL = 'SELLREQUEST_LIST_FAIL'

export const STAT_REQUEST = 'STAT_REQUEST'
export const STAT_SUCCESS = 'STAT_SUCCESS'
export const STAT_FAIL = 'STAT_FAIL'

export const STAT_CHART_REQUEST = 'STAT_CHART_REQUEST'
export const STAT_CHART_SUCCESS = 'STAT_CHART_SUCCESS'
export const STAT_CHART_FAIL = 'STAT_CHART_FAIL'

export const SELLREQUEST_MANAGEMENT_REQUEST = 'SELLREQUEST_MANAGEMENT_REQUEST'
export const SELLREQUEST_MANAGEMENT_SUCCESS = 'SELLREQUEST_MANAGEMENT_SUCCESS'
export const SELLREQUEST_MANAGEMENT_RESET = 'SELLREQUEST_MANAGEMENT_RESET'
export const SELLREQUEST_MANAGEMENT_FAIL = 'SELLREQUEST_MANAGEMENT_FAIL'

export const ORDER_FILTER_REQUEST = 'ORDER_FILTER_REQUEST'
export const ORDER_FILTER_SUCCESS = 'ORDER_FILTER_SUCCESS'
export const ORDER_FILTER_FAIL = 'ORDER_FILTER_FAIL'

export const SELLREQUEST_FILTER_REQUEST = 'SELLREQUEST_FILTER_REQUEST'
export const SELLREQUEST_FILTER_SUCCESS = 'SELLREQUEST_FILTER_SUCCESS'
export const SELLREQUEST_FILTER_FAIL = 'SELLREQUEST_FILTER_FAIL'
export const SELLREQUEST_FILTER_RESET = 'SELLREQUEST_FILTER_RESET'

